export const createCapatalizeText = (str: string) =>
  str?.charAt(0).toUpperCase() + str?.slice(1);
export const createCapatalizeText2 = (str: string) =>
  str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
